import { initializeApp } from "firebase/app";
import { getAnalytics } from "firebase/analytics";
import Configuration from './../config/configuration';
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: Configuration.FIREBASE_API_KEY,
  authDomain: Configuration.FIREBASE_AUTH_DOMAIN,
  projectId: Configuration.FIREBASE_STORAGE_BUCKET,
  storageBucket: Configuration.FIREBASE_STORAGE_BUCKET,
  messagingSenderId: Configuration.FIREBASE_MESSAGING_SENDER_ID,
  appId: Configuration.FIREBASE_APP_ID,
  measurementId: Configuration.FIREBASE_MEASUREMENT_ID
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const analytics = getAnalytics(app);


export { analytics }

